<template>
    <div class="header-box">
        <header class="header-warpper">
            <div class="main clearfix">
                <!-- logo -->
                <div class="logo fl">
                    <img src="../../static/images/logo_02.png" alt="" />
                </div>

                <!-- 登录&注册 -->
                <div class="search fr" style="
                        display: flex;
                        align-items: center;
                        padding-top: 82px;
                    ">
                    <Input v-model.trim="searchVal" size="large" style="width: 260px; margin-right: 20px" placeholder="全站搜索" @on-enter="handleSearch" :readonly="searchFlag">
                    <span slot="append" @click="handleSearch" style="cursor: pointer">
                        <Icon type="ios-search" color="#fff" size="20"></Icon>
                    </span>
                    </Input>
                    <div v-if="!getUserInfo" style="display: flex; flex-direction: row-reverse">
                        <a class="login-btn" @click="ModalOneRegShow" style="margin-left: 20px">注册</a>
                        <a class="login-btn" @click="loginModalShow">登录</a>
                    </div>
                    <div v-else style="display: flex; flex-direction: row-reverse">
                        <Dropdown>
                            <a v-if="userInfo.roleName != '企业'" href="javascript:void(0)" class="user-info-title login-btn">
                                {{ userInfo.userName? userInfo.userName: "新用户，您好!" }}
                                <Icon type="ios-arrow-down" />
                            </a>
                            <a v-if="userInfo.roleName == '企业'" href="javascript:void(0)" class="user-info-title login-btn">
                                {{ userInfo.businessName? userInfo.businessName: "新用户，您好!" }}
                                <Icon type="ios-arrow-down" />
                            </a>
                            <DropdownMenu slot="list">
                                <DropdownItem>
                                    <transition name="fade" mode="out-in">
                                        <router-link v-if="userInfo.roleName != '企业'" :to="{ name: 'UserInfo' }">个人中心</router-link>
                                        <router-link v-if="userInfo.roleName == '企业'" :to="{ name: 'UserEnt' }">企业中心</router-link>
                                    </transition>
                                </DropdownItem>
                                <DropdownItem v-if="choiceSubjectFlag">
                                    <div @click="getAuthSubject">切换身份</div>
                                </DropdownItem>
                                <DropdownItem>
                                    <div @click="exitUser">退出</div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </header>

        <div class="nav_box">
            <ul class="cf nav clearfix">
                <li class="fl" v-for="(item, index) in menuList" :key="index" @click.stop="routeTo(item)" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave(index)">
                    <a>{{ item.title }}</a>
                    <ul class="nav_down_w1" :class="{ open: isActive == index }">
                        <li v-for="(itemSub, index) in item.children" :key="index" @click.stop="routeSubTo(itemSub)">
                            <a>{{ itemSub.title }}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="breadcrumb" style="border-bottom: 2px solid #e9e9e9;background: #f9f9f9;">
            <!-- :style="{'width':$route.path.includes('WMQY_Enroll')?'1300px':'1200px'}" -->
            <div class="main">
                <MainBreadcrumb></MainBreadcrumb>
            </div>
        </div>

        <!-- 注册 -->
        <ModalOneReg ref="ModalOneRegDom" @loginModalShow="loginModalShow" @handleRegister="handleRegister"></ModalOneReg>
        <ModalTwoReg ref="ModalTwoRegDom" @handleRegister="handleRegister"></ModalTwoReg>
        <!-- 登录 -->
        <ModalLogin ref="ModalLoginDom" @postLogin="postLogin"></ModalLogin>
        <!-- 选择身份 -->
        <ModalSubject ref="ModalSubjectDom" :entSysUserList="entSysUserList" @getUserType="getUserType"></ModalSubject>
        <!-- 企业注册 -->
        <ModalComReg ref="ModalComRegDom" @handleComRegister="handleComRegister"></ModalComReg>
    </div>
</template>

<script>
import ModalOneReg from "./ModalOneReg.vue";
import ModalTwoReg from "./ModalTwoReg.vue";
import ModalLogin from "./ModalLogin.vue";
import ModalSubject from "./ModalSubject.vue";
import ModalComReg from "./ModalComReg.vue";
import { getSearchList } from "../api/home.js";
import VueSlideUpDown from "vue-slide-up-down";
import MainBreadcrumb from "./MainBreadcrumb.vue";
import {
    getEntMemberInfoInfo,
    postEntSysUser,
    getEntSysUser,
} from "../api/ent";
import merge from "webpack-merge";
import {
    postRegister,
    postLogin,
    getAuthUser,
    getAuthSubject,
} from "../api/user.js";
export default {
    components: {
        VueSlideUpDown,
        ModalOneReg,
        ModalTwoReg,
        ModalLogin,
        ModalSubject,
        ModalComReg,
        MainBreadcrumb,
    },
    data() {
        return {
            searchVal: "",
            searchFlag: false,

            isActive: false,

            flag: true,
            curRouteName: "",

            entSysUserList: [],

            menuList: [
                {
                    name: "HomePage",
                    url: "/index/HomePage",
                    title: "首页",
                    style: "color:#366df0",
                    children: [],
                },
                {
                    name: "AboutUsList",
                    url: "/index/AboutUsList",
                    title: "协会概况",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "协会简介",
                            id: "8",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会章程",
                            id: "7",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "主要负责人",
                            id: "9",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "驻会机构",
                            id: "1552166349579501570",
                            contentType: "富文本",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会分支机构",
                            id: "1578634605600268290",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "协会历届领导机构",
                            id: "1584857206903312385",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                        {
                            title: "公示信息",
                            id: "1592798884993335298",
                            contentType: "简单列表",
                            url: "/index/AboutUsList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "DynamicList",
                    url: "/index/DynamicList",
                    title: "行业动态",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "通知公告",
                            id: "1552487425756987393",
                            contentType: "简单列表",

                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "市场观察",
                            id: "1552477578156048385",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "媒体报道",
                            id: "1552487757262192642",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "国际视野",
                            id: "1552487847674609665",
                            contentType: "标准列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                        {
                            title: "热点专题",
                            id: "1552487651599286274",
                            contentType: "图片+列表",
                            url: "/index/DynamicList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "PolicyList",
                    url: "/index/PolicyList",
                    title: "政策法规",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "政策文件",
                            id: "1552554113475035137",
                            contentType: "简单列表",
                            url: "/index/PolicyList",
                            type: "1",
                        },
                        {
                            title: "法律法规",
                            id: "1552554060823937025",
                            contentType: "简单列表",
                            url: "/index/PolicyList",
                            type: "1",
                        },
                    ],
                },

                {
                    name: "PartyBuildingList",
                    url: "/index/PartyBuildingList",
                    title: "党建之窗",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "学习资料",
                            id: "1562359332169953282",
                            contentType: "简单列表",
                            url: "/index/PartyBuildingList",
                            type: "1",
                        },
                        {
                            title: "党建活动",
                            id: "1592826663357104130",
                            contentType: "简单列表",
                            url: "/index/PartyBuildingList",
                            type: "1",
                        },
                    ],
                },

                {
                    name: "ResearchList",
                    url: "/index/ResearchList",
                    title: "行业研究",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "行业年报",
                            id: "1552554168751767554",
                            contentType: "简单列表",
                            url: "/index/ResearchList",
                            type: "1",
                        },
                        {
                            title: "市场监测",
                            id: "1552554218177445889",
                            contentType: "简单列表",
                            url: "/index/ResearchList",
                            type: "1",
                        },
                    ],
                },
                {
                    name: "StandardList",
                    url: "/index/StandardList",
                    title: "标准规范",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "国标行标",
                            id: "1552553767805665281",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                        {
                            title: "团体标准",
                            id: "1552553886944870402",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                        {
                            title: "自律规范",
                            id: "1552553938815827969",
                            contentType: "简单列表",
                            url: "/index/StandardList",
                            type: "1",
                        },
                    ],
                },

                {
                    name: "VipList",
                    url: "/index/VipList",
                    title: "会员单位",
                    style: "color:#366df0",
                },
                {
                    name: "VipServies",
                    url: "/index/VipServies",
                    title: "会员服务",
                    style: "color:#366df0",
                },
                // {
                //     name: "",
                //     url: "http://182.92.202.71:9201",
                //     title: "考试中心",
                //     style: "color:#366df0",
                // },

                {
                    name: "MeetingHome",
                    url: "/index/MeetingHome",
                    title: "会议活动",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "协会会议",
                            id: "15",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "演艺博览会",
                            id: "16",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "音乐人才扶持",
                            id: "17",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "剧场大会",
                            id: "18",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },

                        {
                            title: "非遗传播",
                            id: "1595269047878012930",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "网络表演高峰论坛",
                            id: "19",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                        {
                            title: "其他活动",
                            id: "1592808873162080258",
                            contentType: "简单列表",
                            url: "/index/MeetingHome",
                            type: "1",
                        },
                    ],
                },
                // {
                //     name: "CourseHome",
                //     url: "/index/CourseHome",
                //     title: "学习中心",
                //     style: "color:#366df0",
                // },

                {
                    name: "TrainList",
                    url: "",
                    title: "行业培训",
                    style: "color:#366df0",
                    children: [
                        {
                            title: "培训动态",
                            url: "/index/TrainingTrendsList",
                            type: "2",
                        },
                        {
                            title: "剧院剧场",
                            url: "",
                            type: "2",
                        },
                        {
                            title: "演出经纪",
                            url: "",
                            type: "2",
                        },
                        {
                            title: "舞台舞美",
                            url: "/index/WM_HomePage",
                            // url: "",
                            type: "2",
                        },
                        {
                            title: "网络表演",
                            url: "/index/NP_HomePage",
                            // url: "",
                            type: "2",
                        },
                        {
                            title: "艺术普及教育",
                            url: "",
                            type: "2",
                        },
                    ],
                },
            ],

            registerParams: {
                account: "",
                smsCode: "",
                isBusiness: false,
            },

            choiceSubjectFlag: false,

            userType: 1,
        };
    },

    methods: {
        getUserType(val) {
            this.userType = val;
        },

        //企业注册
        ModalComRegShow() {
            let routeUrl = this.$router.resolve({
                path: "/index/RegisterEnt",
            });
            window.open(routeUrl.href, "_blank");
            // this.$refs.ModalComRegDom.modalStatus = true;
        },

        ModalOneRegShow() {
            let routeUrl = this.$router.resolve({
                path: "/index/RegisterUser",
            });
            window.open(routeUrl.href, "_blank");
            return;
            this.$refs.ModalOneRegDom.modalStatus = true;
        },

        loginModalShow() {
            //点击登录，判断主体身份是否
            let routeUrl = this.$router.resolve({
                path: "/index/Login",
            });
            window.open(routeUrl.href, "_blank");
            return;
            this.$refs.ModalLoginDom.modalStatus = true;
        },

        //个人注册并登录
        handleRegister(params) {
            this.registerParams = { ...params };
            postRegister(this.registerParams).then((res) => {
                if (res.code == 200) {
                    postLogin(this.registerParams).then((res) => {
                        if (res.code == 200) {
                            localStorage.setItem("token", res.data);
                            this.$Modal.success({
                                title: "提示",
                                content: "注册并登录成功",
                            });
                            this.$refs.ModalOneRegDom.modalStatus = false;
                            //   this.getAuthUser();
                            this.getAuthSubject(this.registerParams.isBusiness);
                        }
                    });
                }
            });
        },

        //企业注册并登录
        handleComRegister(params) {
            postEntSysUser(params).then((res) => {
                if (res.code == 200) {
                    let loginParams = {
                        account: params.contactPhone,
                        isBusiness: true,
                        smsCode: params.smsCode,
                    };
                    postLogin(loginParams).then((res) => {
                        if (res.code == 200) {
                            localStorage.setItem("token", res.data);
                            this.$Modal.success({
                                title: "提示",
                                content: "注册并登录成功",
                            });
                            this.$refs.ModalComRegDom.modalStatus = false;
                            //   this.getAuthUser();
                            this.getAuthSubject(loginParams.isBusiness);
                        }
                    });
                }
            });
        },

        postLogin(loginParams) {
            postLogin(loginParams).then((res) => {
                if (res.code == 200) {
                    localStorage.setItem("token", res.data);
                    this.$Modal.success({
                        title: "提示",
                        content: "登录成功",
                    });
                    this.$refs.ModalLoginDom.modalStatus = false;
                    // this.getAuthUser();
                    this.getAuthSubject(loginParams.isBusiness);
                }
            });
        },

        //获取主体信息
        getAuthSubject(isBusiness) {
            ///isBusiness  true:企业  false:个人
            getAuthSubject().then((res) => {
                if (res.code == 200) {
                    //企业信息  entSysUserList;   个人信息  personalInfo;
                    console.log("获取主体信息", res.data);
                    let data = res.data;
                    if (isBusiness) {
                        if (data.entSysUserList.length > 1) {
                            this.$refs.ModalSubjectDom.modalStatus = true;
                            this.entSysUserList = data.entSysUserList;
                        } else {
                            this.entSysUserList = data.entSysUserList;
                            this.$store.dispatch(
                                "setUserInfo",
                                this.entSysUserList[0]
                            );
                            localStorage.setItem(
                                "userInfo",
                                JSON.stringify(this.entSysUserList[0])
                            );
                            localStorage.setItem("userType", "2");
                            this.userType = 2;
                        }
                    } else {
                        this.$store.dispatch("setUserInfo", data.personalInfo);
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify(data.personalInfo)
                        );
                        localStorage.setItem("userType", "1");
                        this.userType = 1;
                    }
                }
            });
        },

        //获取用户信息
        // getAuthUser() {
        //     getAuthUser().then((res) => {
        //         if (res.code == 200) {
        //             this.userInfo = res.data;
        //             this.$store.dispatch("setUserInfo", this.userInfo);
        //             localStorage.setItem("userInfo", JSON.stringify(res.data));
        //         }
        //     });
        // },

        ModalTwoRegShow(account) {
            this.registerParams.account = account;
            this.$refs.ModalTwoRegDom.modalStatus = true;
        },

        exitUser() {
            let curRoutePath = this.$route.path;
            let curRouteQuery = this.$route.query;
            // console.log("参数", this.$route.query);
            // console.log("curRoutePath", curRoutePath);
            console.log("111", curRoutePath.indexOf("VipList") >= 0);
            console.log("222", curRouteQuery.activeName == "入会申请");
            localStorage.clear();
            this.$store.dispatch("setUserInfo", "");
            if (
                curRoutePath.indexOf("EntInvoiceInfo") >= 0 ||
                curRoutePath.indexOf("EntVipInfo") >= 0 ||
                curRoutePath.indexOf("user") >= 0 ||
                curRoutePath.indexOf("User") >= 0 ||
                curRoutePath.indexOf("InvoiceInfo") >= 0 ||
                curRoutePath.indexOf("Manager") >= 0 ||
                curRoutePath.indexOf("ModifyPwd") >= 0 ||
                curRoutePath.indexOf("Password") >= 0 ||
                curRoutePath.indexOf("mailInfo") >= 0 ||
                (curRoutePath.indexOf("VipList") >= 0 &&
                    curRouteQuery.activeName == "入会申请") ||
                curRoutePath.indexOf("VipServies") >= 0
            ) {
                this.$router.push({
                    path: "/index/HomePage",
                });
            }
            //网络表演
            if (
                curRoutePath.indexOf("NP_UserPage") >= 0 ||
                curRoutePath.indexOf("NP_TrainPage") >= 0 ||
                curRoutePath.indexOf("NP_EnrollPage") >= 0 ||
                curRoutePath.indexOf("NetCourseVideo") >= 0 ||
                curRoutePath.indexOf("NetCourseContent") >= 0
            ) {
                this.$router.push({
                    path: "/index/NP_HomePage",
                });
            }
            //舞美
            if (
                curRoutePath.indexOf("WM_UserPage") >= 0 ||
                curRoutePath.indexOf("WM_EnrollPage") >= 0 ||
                curRoutePath.indexOf("WM_TrainPage") >= 0 ||
                curRoutePath.indexOf("WM_BUGAIPage") >= 0 ||
                curRoutePath.indexOf("WM_SavePage") >= 0 ||
                curRoutePath.indexOf("WM_ModifyPage") >= 0 ||
                curRoutePath.indexOf("WM_EduPage") >= 0 ||
                curRoutePath.indexOf("WM_CourseContent") >= 0 ||
                curRoutePath.indexOf("WM_CourseVideo") >= 0 ||
                curRoutePath.indexOf("WM_Course") >= 0 ||
                curRoutePath.indexOf("WM_YearRecord") >= 0 ||
                curRoutePath.indexOf("WM_ChangePage") >= 0 ||
                curRoutePath.indexOf("OfflineExamDet") >= 0 ||
                curRoutePath.indexOf("WMQY_UserPage") >= 0 ||
                curRoutePath.indexOf("WMQY_EnrollPage") >= 0 ||
                curRoutePath.indexOf("WMQY_BUGAIPage") >= 0 ||
                curRoutePath.indexOf("WMQY_ModifyPage") >= 0 ||
                curRoutePath.indexOf("WMQY_SavePage") >= 0 ||
                curRoutePath.indexOf("WMQY_ChangePage") >= 0 ||
                curRoutePath.indexOf("WMQY_RenewalPage") >= 0
            ) {
                this.$router.push({
                    path: "/index/WM_HomePage",
                });
            }
        },

        handleMouseEnter(i) {
            this.isActive = i;
        },

        handleMouseLeave(i) {
            this.isActive = 999;
        },

        getFlag() {
            return new Promise((resolve, reject) => {
                let id = JSON.parse(localStorage.getItem("userInfo")).id;
                let vipFlag = false;
                getEntSysUser(id).then((res) => {
                    console.log("res.data", res.data);
                    if (res.code == 200) {
                        if (
                            res.data.emiStatus == 2 &&
                            (res.data.payStatus == 3 ||
                                res.data.payStatus == 5) &&
                            res.data.isValid
                        ) {
                            vipFlag = true;
                        } else {
                            vipFlag = false;
                        }
                        resolve(vipFlag);
                    }
                });
            });
        },

        routeTo(item) {
            // this.$store.dispatch("setLoginStatus", false);
            if (!item.url) {
                return;
            }
            if (item.title == "考试中心") {
                window.open("http://182.92.202.71:9201/");
                return;
            }

            if (item.url == "/index/VipServies") {
                if (localStorage.getItem("userInfo")) {
                    this.getFlag().then((result) => {
                        if (result) {
                            this.$router.push({
                                path: item.url,
                            });
                        } else {
                            this.$Modal.confirm({
                                title: "提示",
                                okText: "查看入会须知",
                                cancelText: "关闭",
                                content:
                                    "<p>您还不是演出协会会员，不可查看相关会员服务内容！</p>",
                                onOk: () => {
                                    this.$router.push({
                                        path: "/index/VipList",
                                        query: {
                                            activeName: "入会须知",
                                            step: 1,
                                        },
                                    });
                                },
                                onCancel: () => {
                                    // this.$Message.info("Clicked cancel");
                                },
                            });
                        }
                    });
                } else {
                    this.$Modal.confirm({
                        title: "提示",
                        okText: "跳转登录",
                        content: "<p>查看会员服务，需用企业账户登录</p>",
                        onOk: () => {
                            let routeUrl = this.$router.resolve({
                                path: "/index/Login",
                                query: {
                                    type: "企业登录",
                                },
                            });
                            window.open(routeUrl.href, "_blank");
                        },
                        onCancel: () => {},
                    });
                    return;
                }
            } else {
                this.$router.push({
                    path: item.url,
                });
            }
        },

        routeSubTo(item) {
            if (item.type == 1) {
                this.$router.push({
                    path: item.url,
                    query: {
                        activeName: item.title,
                        id: item.id,
                        contentType: item.contentType,
                    },
                });
            }
            if (item.type == 2) {
                if (item.url) {
                    this.$router.push({
                        path: item.url,
                    });
                    return;
                    let routeUrl = this.$router.resolve({
                        path: item.url,
                    });
                    window.open(routeUrl.href, "_blank");
                } else {
                    this.$router.push({
                        path: "/index/Project",
                        query: {
                            name: item.title,
                        },
                    });
                    return;
                    let routeUrl = this.$router.resolve({
                        path: "/index/Project",
                    });
                    window.open(routeUrl.href, "_blank");
                }
            }
        },

        handleSearch() {
            if (this.flag) {
                if (this.searchVal.length == 0) {
                    this.$Message.info("请输入检索关键字");
                    this.flag = false;
                    setTimeout(() => {
                        this.flag = true;
                    }, 2000);
                    return;
                }
                this.$router.push({
                    path: "/index/Search",
                    query: {
                        val: this.searchVal,
                    },
                });
                return;
                getSearchList(this.searchVal).then((res) => {
                    if (res.code == 200) {
                        this.flag = false;
                        setTimeout(() => {
                            this.flag = true;
                        }, 2000);
                        let dictName = res.data.dictName;
                        switch (dictName) {
                            case "协会概况": {
                                this.$router.push({
                                    path: "/index/OrganList",
                                });
                                break;
                            }
                            case "政策法规": {
                                this.$router.push({
                                    path: "/index/PolicyList",
                                });
                                break;
                            }
                            case "通知公告": {
                                this.$router.push({
                                    path: "/index/NoticeList",
                                });
                                break;
                            }
                            case "动态信息": {
                                this.$router.push({
                                    path: "/index/InfoList",
                                });
                                break;
                            }
                            case "培训服务": {
                                this.$router.push({
                                    path: "/index/TrainList",
                                });
                                break;
                            }
                            case "协会会员": {
                                this.$router.push({
                                    path: "/index/VipList",
                                });
                                break;
                            }
                        }
                    }
                });
            }
        },

        //获取主体信息
        getAuthSubjectList() {
            getAuthSubject().then((res) => {
                if (res.code == 200) {
                    //企业信息  entSysUserList;   个人信息  personalInfo;
                    let data = res.data;
                    if (data.entSysUserList.length > 1) {
                        this.choiceSubjectFlag = true;
                    } else {
                        this.choiceSubjectFlag = false;
                    }
                }
            });
        },
    },
    created() {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (this.userInfo) {
            this.getAuthSubjectList();
        }
    },
    watch: {
        "$store.getters.getLoginStatus"(val) {
            if (val) {
                this.loginModalShow();
            }
        },
        "$store.getters.getRouterName"(val) {
            if (val == "Search") {
                this.searchFlag = true;
                setTimeout(() => {
                    this.searchVal = "";
                }, 1000);
            } else {
                this.searchFlag = false;
            }
        },
        $route: {
            handler(newVal) {
                if (newVal.query.activeName) {
                    this.$emit("changeActiveStep", newVal.query.activeName);
                    // console.log("哈哈哈哈哈", newVal.query.activeName);
                    // this.$router.push({
                    //     query: merge(this.$route.query, {
                    //         activeName: newVal.query.activeName,
                    //     }),
                    // });

                    // let routeUrl = this.$router.resolve({
                    //     query: {
                    //         activeName: newVal.query.activeName,
                    //     }
                    // });
                    // window.open(routeUrl.href);
                }
            },
        },
    },
    computed: {
        menuDataFilter() {
            this.curRouteName = this.$store.getters.getRouterName;
            console.log("444", this.curRouteName);
            let val = this.$store.getters.getRouterName;
            let menuList = this.menuList;
            menuList.forEach((x) => {
                x.style = "";
                if (x.name === val) {
                    x.style = "background: #0b60a2;color: #fff;";
                }
            });
            return menuList;
        },
        getUserInfo() {
            let userInfoFlag = this.$store.getters.getUserInfo;
            if (localStorage.getItem("userInfo")) {
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                userInfoFlag = true;
                this.getAuthSubjectList();
            } else {
                userInfoFlag = false;
            }
            return userInfoFlag;
        },
        isCom() {
            let isComFlag = false;
            if (localStorage.getItem("userInfo")) {
                let roleName = JSON.parse(
                    localStorage.getItem("userInfo")
                ).roleName;
                if (roleName == "企业") {
                    isComFlag = false;
                } else {
                    isComFlag = true;
                }
            } else {
                isComFlag = true;
            }
            return isComFlag;
        },
    },
};
</script>

<style scoped>
.header-warpper {
    width: 100%;
    height: 155px;
    z-index: 2;
    /* background: url(../../static/images/header_bg.png) repeat-x; */
}

.logo {
    padding-top: 34px;
    /* padding-left: 34px; */
}

.logo img {
    width: 451.5px;
    height: 100px;
}

.search {
    padding-top: 54px;
}

.login-btn {
    display: block;
    font-size: 14px;
    padding: 0;
    height: 40px;
    line-height: 40px;
    color: #2763ce;
    /* border: 1px solid #dbefff !important; */
    /* color: #fff; */
    font-weight: bold;
    text-align: center;
}

.login-btn:hover {
    color: rgba(39, 99, 206, 0.9);
}

/*nav*/
.nav_box {
    width: 100%;
    height: 51px;
    background: #2763ce;
}

.nav_box > .nav {
    width: 1200px;
    margin: 0 auto;
}

.nav_box > .nav > li {
    width: 109.4px;
    height: 51px;
    text-align: center;
    position: relative;
    padding: 15px 0;
    /* background: url(../../static/images/nav_splider.png) no-repeat right center; */
}

.nav_box > .nav > li > a {
    font-size: 16px;
    color: #fff;
    display: block;
    border-right: 2px solid #1554a2;
}

.nav_box > .nav > li:last-child > a {
    border-right: 0;
}

.nav_box > .nav > li:hover {
    background-color: #1554a2 !important;
}

.nav_box > .nav > li:focus {
    background-color: #1554a2 !important;
}

.nav_box > .nav > li:first-child {
    width: 106px;
}

.nav_box > .nav > li:first-child img {
    margin-top: 15px;
}

.nav_box > .nav > li > ul.nav_down {
    position: absolute;
    z-index: 99;
    left: 0;
    top: 51px;
    width: 121px;
    background: #1554a2;
}

.nav_box > .nav > li > ul > li {
    width: 109px;
    margin: 0 auto;
    padding-left: 18px;
    border-bottom: 1px solid #225fab;
    text-align: left;
}

.nav_box > .nav > li > ul > li:first-child {
    border-top: 1px solid #225fab;
}

.nav_box > .nav > li > ul > li:hover {
    background: #3e77de;
}

.nav_box > .nav > li > ul > li > a {
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
}

.nav_box > .nav > li > ul > li.lineHeight_special {
    padding: 10px 0;
    padding-left: 14px;
}

.nav_box > .nav > li > ul > li.lineHeight_special > a {
    line-height: 17px;
}

.nav_box > .nav > li > ul.nav_down_w1 {
    width: 150px;
    z-index: 99;
    position: absolute;
    right: 1;
    top: 51px;
    background: #1554a2;
    max-height: 0;
    transition: max-height 0.9s ease;
    z-index: 99999;
    overflow: hidden;
}

.nav_box > .nav > li > ul.nav_down_w1 > li {
    width: 150px;
}

.nav_box > .nav > li > ul.nav_down_w2 {
    z-index: 99;
    width: 250px;
    position: absolute;
    right: 1;
    top: 51px;
    background: #1554a2;
}

.nav_box > .nav > li > ul.nav_down_w2 > li {
    width: 230px;
}

.open {
    max-height: 500px !important;
    transition: max-height 0.3s;
}
</style>

<style>
.search .ivu-input {
    border: 1px solid #608be4 !important;
    color: #005bab !important;
    border-radius: 0 !important;
}

.search .ivu-input-group-append,
.search .ivu-input-group-prepend {
    border: 1px solid #608be4 !important;
    background: #608be4 !important;
    border-radius: 0 !important;
}

/* .ivu-modal {
    top: 24% !important;
} */
.header-box {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1100;
}
</style>


// WEBPACK FOOTER //
// src/components/MainHeader.vue